/**
 * Feature flags — toggle here until the feature is fully ready.
 * Replace with env-based config if runtime toggling is needed.
 */
export const FEATURE_FLAGS = {
  /** Generate key sends an email — requires SMTP. Set to true once SMTP is configured. */
  EMAIL_ON_KEY_GENERATION: false,
  /** Pilot GEN channel is a staged feature; keep hidden until rollout. */
  PILOT_GEN_CHANNEL: false,
} as const;
